import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h6 q-px-md q-py-md"
}
const _hoisted_2 = { class: "row q-py-md border-bottom flex items-center" }
const _hoisted_3 = { class: "col-12 col-sm-8 q-pt-sm q-pt-sm-none text-body2 q-px-md" }
const _hoisted_4 = {
  key: 0,
  class: "row flex items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-body2"
}

import { PropType, ref, computed } from "vue";

  import { useAuthStore } from "src/stores/auth-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import { LoanApplication, CreditCheck } from "src/types/loan-application/index";

  import DataTable from "./DataTable.vue";
  import { useCurrencyFormatter } from "src/functions";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCheckForm',
  props: {
    creditCheck: {
      type: Object as PropType<CreditCheck>,
      default: {} as CreditCheck
    },
    score247: {
      type: Number,
      default: 0
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {

  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();

  const isMobile = computed(() => settingsStore.isMobile);

  const props = __props

  const scoreColour = computed(() => {
    switch (props.score247) {
      case 0:
        return 'bg-dark'
      case 1:
        return 'bg-warning'
      case 2:
        return 'bg-amber'
      case 3:
        return 'bg-positive'
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Credit Profile"))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-12 col-sm-4 text-subtitle2 q-px-md" }, " 247 Score ", -1)),
      _createElementVNode("div", _hoisted_3, [
        (__props.score247 >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                style: {"width":"50px","border-radius":"5px 0px 0px 5px"},
                class: _normalizeClass(["q-pa-xs q-ml-xs", __props.score247 >= 1 ? scoreColour.value : 'bg-grey-4'])
              }, null, 2),
              _createElementVNode("div", {
                style: {"width":"50px"},
                class: _normalizeClass(["q-pa-xs q-ml-xs", __props.score247 >= 2 ? scoreColour.value : 'bg-grey-4'])
              }, null, 2),
              _createElementVNode("div", {
                style: {"width":"50px","border-radius":"0px 5px 5px 0px"},
                class: _normalizeClass(["q-pa-xs q-ml-xs", __props.score247 === 3 ? scoreColour.value : 'bg-grey-4'])
              }, null, 2)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, " Not approved "))
      ])
    ])
  ], 64))
}
}

})